<template>
  <layouts-header></layouts-header>
  <layouts-sidebar></layouts-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <div class="row">
        <div class="col-md-12">
          <!-- Page Header -->
          <page-header :title="title" />
          <!-- /Page Header -->

          <!-- Settings Menu -->

          <!-- /Settings Menu -->

          <div class="row">
            <div class="col-md-12 col-xl-12 col-lg-12">
              <!-- Info -->
              <div class="card">
                <div class="card-body">
                  <form @submit.prevent="submitForm">
                    <div class="border-bottom mb-3">
                      <div class="row">
                        <div class="col-md-6">
                          <div class="mb-3 position-relative">
                            <label class="form-label"
                              >Organization Name
                              <span class="text-danger">*</span></label
                            >
                            <input
                              type="text"
                              v-model="organizationName"
                              @input="searchProspects"
                              @keydown.down="highlightSuggestion(1)"
                              @keydown.up="highlightSuggestion(-1)"
                              @keydown.enter.prevent="
                                selectHighlightedSuggestion
                              "
                              class="form-control"
                            />
                            <ul
                              v-if="filteredProspects.length"
                              class="list-group suggestion-list"
                            >
                              <li
                                v-for="(prospect, index) in filteredProspects"
                                :key="prospect.id"
                                :class="[
                                  'list-group-item',
                                  { active: index === highlightedIndex },
                                ]"
                                @click="selectSuggestion(prospect)"
                                @mouseenter="highlightIndex(index)"
                              >
                                {{ prospect.organization_name }}
                              </li>
                            </ul>
                            <div
                              class="text-danger"
                              v-if="errors.organization_name"
                            >
                              {{ errors.organization_name[0] }}
                            </div>
                          </div>
                        </div>

                        <!-- <div class="col-md-6">
                          <div class="mb-3">
                            <label class="form-label">Industry Type</label>
                            <multiselect
                              v-model="industryType"
                              :options="industryTypes"
                              track-by="id"
                              label="type"
                              placeholder="Select Industry"
                            >
                            </multiselect>
                          </div>
                        </div> -->
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="col-form-label">Industry Type</label>
                            <input
                              type="text"
                              v-model="industryType"
                              @input="handleIndustryTypeInput"
                              placeholder="Type to search..."
                              class="form-control"
                            />
                            <div
                              v-if="filteredIndustryTypes.length > 0"
                              class="dropdown-box"
                            >
                              <ul>
                                <li
                                  v-for="item in filteredIndustryTypes"
                                  :key="item.id"
                                  @click="selectIndustryTypeItem(item)"
                                >
                                  {{ item.type }}
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="col-form-label"
                              >Information Source</label
                            >
                            <input
                              type="text"
                              v-model="informationSourceQuery"
                              @input="handleInput"
                              placeholder="Type to search..."
                              class="form-control"
                            />
                            <div
                              v-if="filteredInfoSources.length > 0"
                              class="dropdown-box"
                            >
                              <ul>
                                <li
                                  v-for="item in filteredInfoSources"
                                  :key="item.id"
                                  @click="selectInfoSourceItem(item)"
                                >
                                  {{ item.name }}
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="form-label">
                              Phone <span class="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              v-model="phone"
                              class="form-control"
                            />
                            <div class="text-danger" v-if="errors.phone">
                              {{ errors.phone[0] }}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="form-label"> Address </label>
                            <input
                              type="text"
                              v-model="address"
                              class="form-control"
                            />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="col-form-label">
                              Select Leads Priority
                              <span class="text-danger">*</span>
                            </label>
                            <multiselect
                              v-model="priority"
                              :options="priorities"
                              track-by="name"
                              label="name"
                            >
                            </multiselect>
                            <div
                              class="text-danger"
                              v-if="errors.lead_priority"
                            >
                              {{ errors.lead_priority[0] }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="col-form-label">
                              Select Country <span class="text-danger">*</span>
                            </label>
                            <multiselect
                              v-model="countryID"
                              :options="countries"
                              track-by="id"
                              label="name"
                            >
                            </multiselect>
                            <div class="text-danger" v-if="errors.country_id">
                              {{ errors.country_id[0] }}
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="form-label">Select Divisions</label>
                            <multiselect
                              v-model="divisionID"
                              :options="divisions"
                              track-by="id"
                              label="name"
                            >
                            </multiselect>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="form-label">Select District</label>
                            <multiselect
                              v-model="districtID"
                              :options="districts"
                              track-by="id"
                              label="name"
                            >
                            </multiselect>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="col-form-label"
                              >Select Area/Zone</label
                            >
                            <multiselect
                              v-model="zoneID"
                              :options="zones"
                              track-by="id"
                              label="name"
                            >
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="form-label">Website </label>
                            <input
                              type="text"
                              v-model="websiteLink"
                              class="form-control"
                            />
                            <div class="text-danger" v-if="errors.website_link">
                              {{ errors.website_link[0] }}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div
                          v-for="(exhibition, index) in exhibitions"
                          :key="index"
                          class="col-md-12"
                        >
                          <div
                            class="card"
                            style="margin-bottom: unset !important"
                          >
                            <div class="card-header additional-header">
                              <div class="header-index">
                                Exhibition {{ index + 1 }}
                              </div>
                              <div>
                                <button
                                  v-if="exhibitions.length > 1"
                                  class="btn btn-danger btn-sm"
                                  type="button"
                                  @click="removeExhibition(index)"
                                >
                                  Remove
                                </button>
                              </div>
                            </div>
                            <div class="card-body">
                              <div class="">
                                <div class="row">
                                  <div class="col-md-4">
                                    <div class="mb-3">
                                      <label class="form-label">
                                        Exhibition
                                        <span class="text-danger">*</span>
                                      </label>
                                      <multiselect
                                        v-model="exhibition.exhibition_id"
                                        :options="projects"
                                        track-by="id"
                                        label="name"
                                        placeholder="Select Exhibition"
                                      >
                                      </multiselect>
                                      <div
                                        class="text-danger"
                                        v-if="
                                          errors[
                                            `exhibitions.${index}.exhibition_id`
                                          ]
                                        "
                                      >
                                        {{
                                          errors[
                                            `exhibitions.${index}.exhibition_id`
                                          ][0]
                                        }}
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-4">
                                    <label class="form-label">
                                      Assign To
                                      <span class="text-danger">*</span>
                                    </label>
                                    <multiselect
                                      v-model="exhibition.employee_id"
                                      :options="employees"
                                      track-by="id"
                                      label="name"
                                      placeholder="Select Employee"
                                    >
                                    </multiselect>
                                    <div
                                      class="text-danger"
                                      v-if="
                                        errors[
                                          `exhibitions.${index}.employee_id`
                                        ]
                                      "
                                    >
                                      {{
                                        errors[
                                          `exhibitions.${index}.employee_id`
                                        ][0]
                                      }}
                                    </div>
                                  </div>
                                  <div class="col-md-4">
                                    <label class="form-label">
                                      Additional Assign To
                                    </label>
                                    <multiselect
                                      v-model="exhibition.additionalEmployeeID"
                                      :options="employees"
                                      track-by="id"
                                      label="name"
                                      placeholder="Select Additional Assign To"
                                    >
                                    </multiselect>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <button
                        class="btn btn-primary btn-sm mb-2"
                        type="button"
                        @click="addExhibition"
                      >
                        Add New Exhibition
                        <i class="fas fa-plus icon-spacing"></i>
                      </button>
                      <div class="row">
                        <div
                          v-for="(social, index) in socialNetworks"
                          :key="index"
                          class="col-md-12"
                        >
                          <div
                            class="card"
                            style="margin-bottom: unset !important"
                          >
                            <div class="card-header additional-header">
                              <div>Social Network {{ index + 1 }}</div>
                              <div>
                                <button
                                  v-if="socialNetworks.length > 1"
                                  class="btn btn-danger btn-sm"
                                  type="button"
                                  @click="removeSocialNetwork(index)"
                                >
                                  Remove
                                </button>
                              </div>
                            </div>
                            <div class="card-body">
                              <div class="">
                                <div class="row">
                                  <div class="col-md-6">
                                    <div class="mb-3">
                                      <label class="form-label">
                                        Social Media
                                      </label>
                                      <multiselect
                                        v-model="social.mediaName"
                                        :options="socialMedias"
                                        track-by="name"
                                        label="name"
                                        placeholder="Select Social Media"
                                      >
                                      </multiselect>
                                      <div
                                        class="text-danger"
                                        v-if="
                                          errors[
                                            `social_networks.${index}.mediaName`
                                          ]
                                        "
                                      >
                                        {{
                                          errors[
                                            `social_networks.${index}.mediaName`
                                          ][0]
                                        }}
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-6">
                                    <label class="form-label"> URL </label>
                                    <input
                                      type="text"
                                      v-model="social.URL"
                                      class="form-control"
                                    />
                                    <div
                                      class="text-danger"
                                      v-if="
                                        errors[`social_networks.${index}.URL`]
                                      "
                                    >
                                      {{
                                        errors[
                                          `social_networks.${index}.URL`
                                        ][0]
                                      }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <button
                        class="btn btn-primary btn-sm mb-2"
                        type="button"
                        @click="addSocialNetworks"
                      >
                        Add New Social Media
                        <i class="fas fa-plus icon-spacing"></i>
                      </button>
                    </div>

                    <div class="border-bottom mb-3">
                      <div class="row">
                        <div
                          v-for="(person, index) in form.concern_person_info"
                          :key="index"
                          class="col-md-12"
                        >
                          <div class="card">
                            <div class="card-header additional-header">
                              <div>Concern Person {{ index + 1 }}</div>
                              <div>
                                <button
                                  class="btn btn-danger btn-sm"
                                  type="button"
                                  @click="removeConcernPerson(index)"
                                >
                                  Remove
                                  <i class="fas fa-trash icon-spacing"></i>
                                </button>
                              </div>
                            </div>
                            <div class="card-body">
                              <div class="mb-3">
                                <div class="row">
                                  <div class="col-md-12">
                                    <div class="mb-3">
                                      <label class="form-label">
                                        Concern Person Name
                                        <span class="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        class="form-control"
                                        v-model="person.name"
                                      />
                                      <div
                                        class="text-danger"
                                        v-if="getErrorMessage(index, 'name')"
                                      >
                                        {{ getErrorMessage(index, "name") }}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-md-6">
                                    <div class="mb-3">
                                      <label class="form-label">
                                        Phone <span class="text-danger">*</span>
                                      </label>
                                      <div class="phone-input-container">
                                        <div
                                          v-for="(
                                            phone, phoneIndex
                                          ) in person.phone"
                                          :key="phoneIndex"
                                          class="phone-tag"
                                        >
                                          {{ phone }}
                                          <span
                                            class="remove-phone"
                                            @click="
                                              removePhone(index, phoneIndex)
                                            "
                                            >&times;</span
                                          >
                                        </div>
                                        <input
                                          type="text"
                                          class="form-control phone-input"
                                          v-model="newPhone"
                                          @keydown="addPhone($event, index)"
                                          @blur="addPhoneOnBlur(index)"
                                          placeholder="Add phone number"
                                        />
                                      </div>
                                      <div
                                        class="text-danger"
                                        v-if="
                                          getErrorMessage(index, 'phone') ||
                                          getErrorMessageComplex(index, 'phone')
                                        "
                                      >
                                        {{
                                          getErrorMessage(index, "phone") ||
                                          getErrorMessageComplex(index, "phone")
                                        }}
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-6">
                                    <div class="mb-3">
                                      <label class="form-label">
                                        Email <span class="text-danger">*</span>
                                      </label>
                                      <div class="phone-input-container">
                                        <div
                                          v-for="(
                                            email, emailIndex
                                          ) in person.email"
                                          :key="emailIndex"
                                          class="phone-tag"
                                        >
                                          {{ email }}
                                          <span
                                            class="remove-phone"
                                            @click="
                                              removeEmail(index, emailIndex)
                                            "
                                            >&times;</span
                                          >
                                        </div>
                                        <input
                                          type="text"
                                          class="form-control phone-input"
                                          v-model="newEmail"
                                          @keydown="addEmail($event, index)"
                                          @blur="addEmailOnBlur(index)"
                                          placeholder="Add email address"
                                        />
                                      </div>
                                      <div
                                        class="text-danger"
                                        v-if="
                                          getErrorMessage(index, 'email') ||
                                          getErrorMessageComplex(index, 'email')
                                        "
                                      >
                                        {{
                                          getErrorMessage(index, "email") ||
                                          getErrorMessageComplex(index, "email")
                                        }}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-md-6">
                                    <div class="mb-3">
                                      <label class="col-form-label"
                                        >Date Of Birth</label
                                      >
                                      <Datepicker
                                        v-model="person.dob"
                                        :range="false"
                                        :clearable="true"
                                        :format="format"
                                        placeholder="Select a date"
                                      />
                                      <div
                                        class="text-danger"
                                        v-if="
                                          getErrorMessage(index, 'dob') ||
                                          getErrorMessageComplex(index, 'dob')
                                        "
                                      >
                                        {{
                                          getErrorMessage(index, "dob") ||
                                          getErrorMessageComplex(index, "dob")
                                        }}
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-6">
                                    <div class="mb-3">
                                      <label class="form-label"
                                        >Designation</label
                                      >
                                      <multiselect
                                        v-model="person.designation"
                                        :options="
                                          getFilteredOptions('designations')
                                        "
                                        track-by="name"
                                        label="name"
                                        placeholder="Select designation"
                                        @search-change="
                                          (search) =>
                                            onSearchChange(search, designations)
                                        "
                                        :allow-empty="false"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-md-6">
                                    <div class="mb-3">
                                      <label class="col-form-label"
                                        >Influencing Role</label
                                      >
                                      <multiselect
                                        v-model="person.role"
                                        :options="roles"
                                        track-by="name"
                                        label="name"
                                        placeholder="Select role"
                                      >
                                      </multiselect>
                                    </div>
                                  </div>
                                  <div class="col-md-6">
                                    <div class="mb-3">
                                      <label class="col-form-label"
                                        >Department</label
                                      >
                                      <multiselect
                                        v-model="person.department"
                                        :options="
                                          getFilteredOptions('departments')
                                        "
                                        track-by="name"
                                        label="name"
                                        placeholder="Select department"
                                        @search-change="
                                          (search) =>
                                            onSearchChange(search, departments)
                                        "
                                      >
                                      </multiselect>
                                    </div>
                                  </div>
                                </div>

                                <div class="row">
                                  <div class="col-md-6">
                                    <div class="mb-3">
                                      <label class="col-form-label"
                                        >Gender</label
                                      >

                                      <select
                                        class="form-control"
                                        v-model="person.gender"
                                      >
                                        <option value="" disabled="true">
                                          select gender
                                        </option>
                                        <option value="male">Male</option>
                                        <option value="female">Female</option>
                                        <option value="others">Others</option>
                                      </select>
                                      <div
                                        class="text-danger"
                                        v-if="
                                          getErrorMessage(index, 'gender') ||
                                          getErrorMessageComplex(
                                            index,
                                            'gender'
                                          )
                                        "
                                      >
                                        {{
                                          getErrorMessage(index, "gender") ||
                                          getErrorMessageComplex(
                                            index,
                                            "gender"
                                          )
                                        }}
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-6">
                                    <div class="mb-3">
                                      <label class="col-form-label"
                                        >Attachment Visiting Card
                                      </label>
                                      <input
                                        type="file"
                                        class="form-control"
                                        @change="
                                          handleFileUpload($event, index)
                                        "
                                      />
                                      <div
                                        class="text-danger"
                                        v-if="
                                          getErrorMessage(
                                            index,
                                            'attachment'
                                          ) ||
                                          getErrorMessageComplex(
                                            index,
                                            'attachment'
                                          )
                                        "
                                      >
                                        {{
                                          getErrorMessage(
                                            index,
                                            "attachment"
                                          ) ||
                                          getErrorMessageComplex(
                                            index,
                                            "attachment"
                                          )
                                        }}
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="row">
                                  <div
                                    v-for="(
                                      social, socialIndex
                                    ) in person.social_networks"
                                    :key="socialIndex"
                                    class="col-md-12"
                                  >
                                    <div
                                      class="card"
                                      style="margin-bottom: unset !important"
                                    >
                                      <div
                                        class="card-header additional-header"
                                      >
                                        <div>
                                          Social Network {{ socialIndex + 1 }}
                                        </div>
                                        <div>
                                          <button
                                            class="btn btn-danger btn-sm"
                                            type="button"
                                            @click="
                                              removeSocialNetworkConcern(
                                                index,
                                                socialIndex
                                              )
                                            "
                                          >
                                            Remove
                                            <i
                                              class="fas fa-trash icon-spacing"
                                            ></i>
                                          </button>
                                        </div>
                                      </div>
                                      <div class="card-body">
                                        <div class="">
                                          <div class="row">
                                            <div class="col-md-6">
                                              <div class="mb-3">
                                                <label class="form-label">
                                                  Social Media
                                                </label>
                                                <select
                                                  class="form-control"
                                                  v-model="social.social_media"
                                                >
                                                  <option
                                                    value=""
                                                    disabled="true"
                                                  >
                                                    select social type
                                                  </option>
                                                  <option value="facebook">
                                                    Facebook
                                                  </option>
                                                  <option value="youtube">
                                                    YouTube
                                                  </option>
                                                  <option value="linkedin">
                                                    LinkedIn
                                                  </option>
                                                  <option value="other">
                                                    Other
                                                  </option>
                                                </select>
                                                <div
                                                  class="text-danger"
                                                  v-if="
                                                    getErrorMessageUrl(
                                                      index,
                                                      'social_networks',
                                                      socialIndex,
                                                      'social_media'
                                                    )
                                                  "
                                                >
                                                  {{
                                                    getErrorMessageUrl(
                                                      index,
                                                      "social_networks",
                                                      socialIndex,
                                                      "social_media"
                                                    )
                                                  }}
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-6">
                                              <label class="form-label">
                                                URL
                                              </label>
                                              <input
                                                type="text"
                                                class="form-control"
                                                v-model="social.url"
                                              />
                                              <div
                                                class="text-danger"
                                                v-if="
                                                  getErrorMessageUrl(
                                                    index,
                                                    'social_networks',
                                                    socialIndex,
                                                    'url'
                                                  )
                                                "
                                              >
                                                {{
                                                  getErrorMessageUrl(
                                                    index,
                                                    "social_networks",
                                                    socialIndex,
                                                    "url"
                                                  )
                                                }}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <button
                                  class="btn btn-primary btn-sm mb-2"
                                  type="button"
                                  @click="addNewSocialNetwork(index)"
                                >
                                  Add New Social Media
                                  <i class="fas fa-plus icon-spacing"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <button
                        class="btn btn-primary btn-sm mb-3"
                        type="button"
                        @click="addNewConcernPerson"
                      >
                        Add Another Concern Person
                      </button>
                    </div>

                    <div class="btn-list">
                      <button
                        style="float: right"
                        type="submit"
                        :disabled="isLoading"
                        class="btn btn-success"
                      >
                        Save Information
                        <span
                          v-if="isLoading"
                          class="spinner-border spinner-border-sm ms-2"
                        ></span>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <!-- /Info -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- /Add New View -->
</template>

<script>
import http from "@/utils/http";
import Multiselect from "vue-multiselect";
import { mapGetters } from "vuex";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";

export default {
  components: {
    Multiselect,
    Datepicker,
  },
  data() {
    return {
      //initial info
      isLoading: false,
      title: "Create New Lead",

      prospects: [],
      selectedProspect: null,
      highlightedIndex: -1,
      filteredProspects: [],

      organizationName: "",
      industryTypes: [],
      filteredIndustryTypes: [],
      industryType: "",
      industryTypeId: "",

      informationSources: [],
      filteredInfoSources: [],
      informationSourceQuery: "",
      informationSourceId: "",
      debounceTimeout: null,

      phone: "",
      address: "",

      priorities: [
        { name: "Very Good" },
        { name: "Good" },
        { name: "Low" },
        { name: "Very Low" },
      ],
      priority: null,

      countries: [],
      countryID: "",
      divisions: [],
      divisionID: "",
      districts: [],
      districtID: "",
      zones: [],
      zoneID: "",

      websiteLink: "",

      exhibitions: [
        {
          exhibition_id: "",
          employee_id: "",
          additionalEmployeeID: "",
        },
      ],
      employees: [],
      projects: [],

      socialNetworks: [{ mediaName: "", URL: "" }],
      socialMedias: [
        { id: 1, name: "Facebook" },
        { id: 2, name: "Instagram" },
        { id: 3, name: "Twiter" },
        { id: 4, name: "linkedin" },
      ],
      errors: {},

      //concern info
      format: "yyyy-MM-dd",
      designations: [],
      departments: [],
      roles: [],

      form: {
        //todo: remove from here, lead id catch from backend session
        concern_person_info: [
          {
            name: "",
            phone: [],
            email: [],
            dob: "",
            designation: null,
            role: null,
            department: null,
            gender: "",
            attachment: "",
            social_networks: [
              {
                social_media: "",
                url: "",
              },
            ],
          },
        ],
      },
      newPhone: "",
      newEmail: "",

      designationCustomValue: null,
      roleCustomValue: null,
      departmentCustomValue: null,
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),

    //concern
    getFilteredOptions() {
      return (source) => {
        let options = [];
        if (source === "designations") {
          options = this.designations;
        } else if (source === "departments") {
          options = this.departments;
        }

        // Add custom value for designations if it exists
        if (source === "designations" && this.designationCustomValue) {
          options = [{ id: null, name: this.designationCustomValue }].concat(
            options
          );
        } else if (source === "departments" && this.departmentCustomValue) {
          options = [{ id: null, name: this.departmentCustomValue }].concat(
            options
          );
        }

        return options;
      };
    },
  },

  watch: {
    countryID(newValue) {
      if (newValue) {
        this.getDivisionsByCountry();
        console.log({
          id: this.userInfo.employee.id,
          name: this.userInfo.name,
        });
      }
    },
    divisionID(newValue) {
      if (newValue) {
        this.getDistrictsByDivision();
      }
    },
    districtID(newValue) {
      if (newValue) {
        this.getZonesByDistrict();
      }
    },
    selectedProspect(newValue) {
      if (newValue) {
        if(newValue?.concern_person_info )
        this.form.concern_person_info = newValue?.concern_person_info || null;
      }
    },
    userInfo: {
      handler(newVal) {
        if (newVal?.employee?.id && !this.exhibitions[0].employee_id) {
          this.exhibitions[0].employee_id = {
            id: newVal.employee.id,
            name: newVal.name,
          };
        }
      },
      immediate: true,
      deep: true,
    },

    //concern
    selectedDesignation: {
      handler(newValues) {
        newValues.forEach((value, index) => {
          this.form.concern_person_info[index].designation = value;
        });
      },
      deep: true,
    },
    // Watch the entire form object
    form: {
      handler(newValue, oldValue) {
        console.log("Form updated:", newValue);
        console.log("Previous state:", oldValue);
      },
      deep: true,
    },
  },
  mounted() {
    this.getIndustryTypes();
    this.getInformationSource();
    this.getCountries();
    this.getEmployees();
    this.getExhibitions();
    this.getProspects();

    //concern
    this.getDepartments();
    this.getDesignations();
    this.getRoles();
  },
  methods: {
    async getProspects() {
      const endpoint = `/prospects-list`;
      const method = "get";
      try {
        const response = await http[method](endpoint);
        this.prospects = response.data.contents;
      } catch (error) {
        //
      }
    },
    searchProspects() {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => {
        const query = this.organizationName.toLowerCase();
        this.filteredProspects = this.prospects.filter((prospect) =>
          prospect.organization_name
            ? prospect.organization_name.toLowerCase().includes(query)
            : false
        );
        this.highlightedIndex = -1;
      }, 300);

      
    },
    selectSuggestion(prospect) {
      this.selectedProspect = prospect;
      this.organizationName = prospect.organization_name;
      this.industryType = prospect?.industry ? prospect?.industry?.type : "";
      this.industryTypeId = prospect?.industry ? prospect?.industry?.id : "";
      this.phone = prospect.phone;
      this.address = prospect.address;
      this.websiteLink = prospect.website_link;
      this.socialNetworks = prospect.social_networks;
      this.filteredProspects = [];
    },
    highlightSuggestion(direction) {
      if (!this.filteredProspects.length) return;

      this.highlightedIndex += direction;
      if (this.highlightedIndex < 0) {
        this.highlightedIndex = this.filteredProspects.length - 1;
      } else if (this.highlightedIndex >= this.filteredProspects.length) {
        this.highlightedIndex = 0;
      }
    },
    highlightIndex(index) {
      this.highlightedIndex = index;
    },
    selectHighlightedSuggestion() {
      if (this.highlightedIndex !== -1) {
        console.log('slecte')
        this.selectSuggestion(this.filteredProspects[this.highlightedIndex]);
      }
    },

    async getIndustryTypes() {
      try {
        const response = await http.get("industries");
        this.industryTypes = response.data.contents;
        if (this.industryType != "") {
          const foundIndustry = response.data.contents.find(
            (data) => data.id == this.industryType
          );
          if (foundIndustry) {
            this.industryType = foundIndustry;
          }
        }
      } catch (error) {
        console.error("Error:", error);
      }
    },

    async getExhibitions() {
      const endpoint = `/exhibitions`;
      const method = "get";
      try {
        const response = await http[method](endpoint);
        this.projects = response.data.contents;
      } catch (error) {
        //
      }
    },
    async getEmployees() {
      const endpoint = `/employees`;
      const method = "get";
      try {
        const response = await http[method](endpoint);
        this.employees = response.data.contents.map((employee) => {
          return {
            id: employee.id,
            name: employee?.user?.name,
          };
        });
      } catch (error) {
        //
      }
    },
    async getCountries() {
      const endpoint = `/countries`;
      const method = "get";
      try {
        const response = await http[method](endpoint);
        this.countries = response.data.contents;
      } catch (error) {
        //
      }
    },
    async getDivisionsByCountry() {
      this.divisions = [];
      const endpoint = `/divisions-by-country`;
      const method = "post";
      let body = {
        country_id: this.countryID.id,
      };
      try {
        const response = await http[method](endpoint, body);
        this.divisions = response.data.contents;
      } catch (error) {
        //
      }
    },

    async getDistrictsByDivision() {
      this.districts = [];
      const endpoint = `/districts-by-division`;
      const method = "post";
      let body = {
        division_id: this.divisionID.id,
      };
      try {
        const response = await http[method](endpoint, body);
        this.districts = response.data.contents;
      } catch (error) {
        //
      }
    },

    async getZonesByDistrict() {
      this.districts = [];
      const endpoint = `/zones-by-district`;
      const method = "post";
      let body = {
        district_id: this.districtID.id,
      };
      try {
        const response = await http[method](endpoint, body);
        this.zones = response.data.contents;
      } catch (error) {
        //
      }
    },

    handleInput() {
      if (this.informationSourceQuery.length > 2) {
        clearTimeout(this.debounceTimeout);
        this.debounceTimeout = setTimeout(() => {
          this.fetchResults();
        }, 300);
      } else {
        this.filteredInfoSources = [];
      }
    },

    handleIndustryTypeInput() {
      if (this.industryType.length > 2) {
        clearTimeout(this.debounceTimeout);
        this.debounceTimeout = setTimeout(() => {
          this.fetchIndustryTypeResults();
        }, 300);
      } else {
        this.filteredIndustryTypes = [];
      }
    },

    fetchResults() {
      const query = this.informationSourceQuery.toLowerCase();
      this.filteredInfoSources = this.informationSources.filter((source) =>
        source.name.toLowerCase().includes(query)
      );
    },

    fetchIndustryTypeResults() {
      const query = this.industryType.toLowerCase();
      this.filteredIndustryTypes = this.industryTypes.filter((industry) =>
        industry.type.toLowerCase().includes(query)
      );
    },

    async getInformationSource() {
      try {
        const response = await http["post"]("get-information-sources", {});
        this.informationSources = response.data.contents;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    selectInfoSourceItem(item) {
      this.informationSourceQuery = item.name;
      this.informationSourceId = item.id;
      this.filteredInfoSources = [];
    },

    selectIndustryTypeItem(item) {
      console.log("item selected:", item);
      this.industryType = item.type;
      this.industryTypeId = item.id;
      this.filteredIndustryTypes = [];
    },

    addExhibition() {
      this.exhibitions.push({
        exhibition_id: "",
        employee_id: {
          id: this.userInfo?.employee?.id,
          name: this.userInfo?.name,
        },
        additionalEmployeeID: "",
      });
    },

    removeExhibition(index) {
      this.exhibitions.splice(index, 1);
    },

    addSocialNetworks() {
      this.socialNetworks.push({
        mediaName: "",
        URL: "",
      });
    },

    removeSocialNetwork(index) {
      this.socialNetworks.splice(index, 1);
    },

    async submitForm() {
      this.isLoading = true;
      const endpoint = "/store-leads-initial-info";
      const method = "post";
      let body = {
        organization_name: this.organizationName,
        industry_type_text: this.industryType,
        industry_type_id: this.industryTypeId,
        information_source_id: this.informationSourceId,
        information_source_text: this.informationSourceQuery,
        phone: this.phone,
        address: this.address,
        lead_priority: this.priority?.name,
        zone_id: this.zoneID ? this.zoneID.id : "",
        country_id: this.countryID.id,
        website_link: this.websiteLink,
        exhibitions: this.exhibitions,
        social_networks: this.socialNetworks,

        concern_person_info: this.form.concern_person_info,
      };
      try {
        const response = await http[method](endpoint, body);

        this.$toast.success(response.data.message);
        this.$router.push("/leads-organization/leads-index");
      } catch (error) {
        // this.errors = error.response.data.errors;
        const errors = error.response?.data?.errors;
        if (errors && Object.keys(errors).length > 0) {
          this.errors = error.response.data.errors;
        } else {
          if (error.response?.data?.message) {
            this.$toast.error(error.response.data.message); // Display the error message in a toast
          } else {
            this.$toast.error("An unexpected error occurred!"); // Fallback message
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    //concern info
    getErrorMessage(index, field) {
      const key = `concern_person_info.${index}.${field}`;
      return this.errors[key] ? this.errors[key][0] : null;
    },
    getErrorMessageComplex(index, field) {
      const key = `concern_person_info.${index}.${field}.0`;
      return this.errors[key] ? this.errors[key][0] : null;
    },
    getErrorMessageUrl(index, field, subIndex, subField) {
      const key = `concern_person_info.${index}.${field}.${subIndex}.${subField}`;
      return this.errors[key] ? this.errors[key][0] : null;
    },
    onSearchChange(search, optionsArray) {
      const exists = optionsArray.some(
        (option) => option.name.toLowerCase() === search.toLowerCase()
      );

      // Determine which custom value to update
      if (optionsArray === this.designations) {
        if (!exists && search.trim()) {
          this.designationCustomValue = search; // Update designation custom value
        } else {
          this.designationCustomValue = null;
        }
      } else if (optionsArray === this.departments) {
        if (!exists && search.trim()) {
          this.departmentCustomValue = search; // Update department custom value
        } else {
          this.departmentCustomValue = null;
        }
      }
    },
    //search end
    addNewConcernPerson() {
      this.form.concern_person_info.push({
        name: "",
        phone: [],
        email: [],
        dob: "",
        designation: null,
        role: null,
        department: null,
        gender: "",
        attachment: "",
        social_networks: [
          {
            social_media: "",
            url: "",
          },
        ],
      });
    },

    //get departments, designations, roles
    async getDepartments() {
      const endpoint = `/departments`;
      const method = "get";
      try {
        const response = await http[method](endpoint);
        this.departments = response.data.contents.map((department) => ({
          id: department.id,
          name: department.name,
        }));
      } catch (error) {
        //
      }
    },
    async getDesignations() {
      const endpoint = `/designations`;
      const method = "get";
      try {
        const response = await http[method](endpoint);
        this.designations = response.data.contents.map((designation) => ({
          id: designation.id,
          name: designation.name,
        }));
      } catch (error) {
        //
      }
    },
    async getRoles() {
      const endpoint = `/influencing-roles`;
      const method = "get";
      try {
        const response = await http[method](endpoint);
        this.roles = response.data.contents.map((role) => ({
          id: role.id,
          name: role.name,
        }));
      } catch (error) {
        //
      }
    },
    handleFileUpload(event, index) {
      const file = event.target.files[0]; // Get the first selected file
      if (file) {
        const formData = new FormData();
        formData.append("file", file);

        // Send the file to the backend
        http
          .post("/upload-file", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((response) => {
            if (response.data.success) {
              // Save the file name returned from the backend
              this.form.concern_person_info[index].attachment =
                response.data.file_name;
            }
          })
          .catch((error) => {
            console.error("File upload failed:", error);
          });
      }
    },

    removeConcernPerson(index) {
      this.form.concern_person_info.splice(index, 1);
    },

    addNewSocialNetwork(index) {
      this.form.concern_person_info[index].social_networks.push({
        social_media: "",
        url: "",
      });
    },

    removeSocialNetworkConcern(index, socialIndex) {
      this.form.concern_person_info[index].social_networks.splice(
        socialIndex,
        1
      );
    },

    addPhone(event, index) {
      if (event.key === "Enter" || event.key === "Tab") {
        event.preventDefault();

        const phone = this.newPhone.trim();

        if (
          phone &&
          !this.form.concern_person_info[index].phone.includes(phone)
        ) {
          this.form.concern_person_info[index].phone.push(phone);
          this.newPhone = ""; // Clear the input
        }
      }
    },
    addPhoneOnBlur(index) {
      const phone = this.newPhone.trim();

      if (
        phone &&
        !this.form.concern_person_info[index].phone.includes(phone)
      ) {
        this.form.concern_person_info[index].phone.push(phone);
        this.newPhone = ""; // Clear the input
      }
    },

    removePhone(index, phoneIndex) {
      this.form.concern_person_info[index].phone.splice(phoneIndex, 1);
    },

    addEmail(event, index) {
      if (event.key === "Enter" || event.key === "Tab") {
        event.preventDefault();

        const email = this.newEmail.trim();

        if (
          email &&
          !this.form.concern_person_info[index].email.includes(email)
        ) {
          this.form.concern_person_info[index].email.push(email);
          this.newEmail = "";
        }
      }
    },
    addEmailOnBlur(index) {
      const email = this.newEmail.trim();
      if (
        email &&
        !this.form.concern_person_info[index].email.includes(email)
      ) {
        this.form.concern_person_info[index].email.push(email);
        this.newEmail = "";
      }
    },

    removeEmail(index, emailIndex) {
      this.form.concern_person_info[index].email.splice(emailIndex, 1);
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>

<style scoped>
.dropdown-box {
  position: relative;
  border: 1px solid #ddd;
  max-height: 150px;
  overflow-y: auto;
  background: #fff;
  margin-top: 5px;
}

.dropdown-box ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.dropdown-box li {
  padding: 10px;
  cursor: pointer;
  transition: background 0.3s;
}

.dropdown-box li:hover {
  background: #f0f0f0;
}

.suggestion-list {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 10;
  max-height: 200px;
  overflow-y: auto;
  background: white;
  border: 1px solid #ddd;
}

.suggestion-list .active {
  background-color: #007bff;
  color: white;
}
</style>
